import { useNavigate } from "react-router-dom";
import { useAlert } from "../../../../../../context/AlertContext";
import LoaderHelper from "../../../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../../../api/AuthService";
import AssetCreateaPage from "../../../../../../entities/DashboardPage/AccountingModule/Customer/AssetsManagement/CreateAssets";

const AssetsCreate = () => {
  const { showAlert } = useAlert();
  const navigate = useNavigate()

  const createNewAsset = async (assetData) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleCreateNewAsset(assetData);
      if (result?.success) {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
        navigate("/dashboard/assetsHome");
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message || "Failed to create asset", "error");
      }
    } catch (apiError) {
      LoaderHelper.loaderStatus(false);
      return;
    }
  }

  return (
    <AssetCreateaPage
      createNewAsset={createNewAsset}
    />
  )
};
export default AssetsCreate;
